import React from "react";
import {
  styled,
  Stack,
  Typography,
  Box,
  Button,
} from "@mui/material";
import '../App.css';

export interface TopbarProps {
  options: {
    label: string;
    value?: string;
    subOptions?: { label?: string; value?: string }[];
  }[];
}

const CustomNavigation = styled(Stack)(({ theme }: any) => ({
  position: "relative",
  padding: "18px 15px",
  cursor: "pointer",
  "&:hover": {
    background: theme.palette.common.backgroundBlack,
    "& .navigation-content": {
      display: "flex"
    }
  },
  "& .navigation-content": {
    display: "none",
    position: "absolute",
    backgroundColor: theme.palette.common.backgroundBlack,
    zIndex: 1,
    top: 59,
    left: 0,
    borderRadius: 0,
    padding: "0px 15px",
    flexDirection: "column",
    minWidth: 135
  }
}));

const Topbar = ({ options }: TopbarProps) => {
  return (
    <Stack className="background-black" alignItems="center">
      <Stack direction="row" width="85%" py={3}>
        <Stack justifyContent="center">
          <img src="/assets/logo.png" width="258.6px" height="53.6px" alt="logo" />
        </Stack>
        <Stack flex={1} justifyContent="flex-end" direction="row" spacing={3} alignItems="center">
          {options.map((option) => {
            return (
              <CustomNavigation>
                <Stack direction="row" spacing={1.5}>
                  <Typography className="font-white" variant="h5">{option.label}</Typography>
                  {option.subOptions && option.subOptions.length > 0 &&
                    <i className="far fa-chevron-down icon-sm font-white" />
                  }
                </Stack>
                {option.subOptions && option.subOptions.length > 0 &&
                  <Box className="navigation-content">
                    {option.subOptions.map((item) =>
                      <Typography variant="h5" className="font-white" mb={1.875}>{item.label}</Typography>
                    )}
                  </Box>
                }
              </CustomNavigation>
            )
          })}
          <Button variant="contained" color="primary">Log In</Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
export default Topbar;
